import React from "react";
import {withApollo} from "react-apollo";

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard";

import IconButton from "components/CustomButtons/IconButton";

import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import PageviewIcon from "@material-ui/icons/Pageview";
import Close from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Tooltip from 'material-ui/Tooltip';

import ReactTable from "react-table";

import { getProjectGroups, getUserGroups, deleteGroup, 
        deleteUserFromGroup, getProjectUsers, 
        addMembersToGroup } from "../../users/graph";
import SweetAlertConfirm from "../../etc/modals/SweetAlertConfirm.jsx";

import ViewGroupModal from "./ViewGroupModal.jsx";


class Groups extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            groups: [],
            isViewGroupModalOpen: false,
            isConfirmModalOpen: false,
            groupMembers: [],
            loading: true,
            selectedGroup: null,
            pid: this.props.match.params.projid,
            groupId: null,
            options: [],
            selectValue: null,
            isAddMember: false
        };
        this.headers = [
            {Header:"Group ID",accessor:"groupId"},
            {Header:"Name",accessor:"name"},
            {
              Header:"Actions",
              accessor:"actions",
              minWidth: 200,
              sortable:false,
              filterable:false
            }
        ];
    }
    componentDidMount(){
        this.fetchData();
    }
    fetchData = () => {
        const { client, match } = this.props; 
        this.setState({
            loading: true
        });
        client.query({
            query: getProjectGroups,
            variables: ({
                pid: match.params.projid
            }),
            fetchPolicy: "network-only",
            errorPolicy: "all"
        }).then((data) => {
            this.setState({
                groups: data.data.getProjectGroups,
                loading: false
            });
        }).catch((error) => {
   
        });
    }
    openViewGroupModal = (groupId,event) => {
        this.setState({isViewGroupModalOpen: true});
        this.fetchGroupData(groupId);
                
    }
    fetchGroupData = (groupId) => {
        this.props.client.query({
            query: getUserGroups,
            variables: ({
                groupId: parseInt(groupId)
            }),
            fetchPolicy: "network-only",
            errorPolicy: "all"
        }).then((data) => {
            this.setState({
                groupMembers: data.data.getGroupMembers,
                groupId: groupId
            });
        }).catch((error) => {
   
        });
    }
    openDeleteModal = (groupId, event) => {
        this.setState({
            isConfirmModalOpen: true,
            selectedGroup: groupId
        });
    }
    onCloseConfirmModal = (event) => {
        this.setState({
            isConfirmModalOpen: false
        });
    }

    deleteGroup = (groupId,event) => {
        this.props.client.mutate({
            mutation: deleteGroup,
            variables: {
                groupId: parseInt(groupId)
            },
            fetchPolicy: "no-cache",
            errorPolicy: "all"
        }).then((data) => {
            this.setState({
                isConfirmModalOpen: false
            });
            this.fetchData();
        }).catch((error) => {
   
        });
    }

    onCloseViewGroupModal = () => {
        this.setState({
            isViewGroupModalOpen: false
        });
    }

    onUsersSelectChange = (value) => {
        this.setState({
          selectValue:value
        });
    }

    addMembers = () => {
        let users = this.state.selectValue.map(x => x.value);

        this.props.client.mutate({
            mutation: addMembersToGroup,
            variables: {
                users: users,
                groupId: this.state.groupId
            },
            fetchPolicy: "no-cache",
            errorPolicy: "all"
        }).then((data) => {
   
            alert("Users added to group");
            this.fetchGroupData(this.state.groupId);
            this.setState({
                isAddMember: false,
                selectValue: []
            });
        }).catch((error) => {
   
        })

    }

    changeToAddMembersView = () => {
        this.props.client.query({
            query: getProjectUsers,
            variables: {
                pid: parseInt(this.state.pid)
            },
            fetchPolicy: "network-only",
            errorPolicy: "all"
        }).then((data) => {
   
            let options = [];
            data.data.getProjectUsers.map((user, index) => {
                options.push({label: user.username, value: user.uid})
            });

            this.setState({
                options: options,
                isAddMember: true
            });
        }).catch((error) => {
            alert("Error in changing to add members view");
        });
    }

    removeMember = (userId,groupId, event) => {
        if(window.confirm(`Delete USER ID: ${userId} from group?`) === true){
            this.props.client.mutate({
                mutation: deleteUserFromGroup,
                variables: {
                    groupId: parseInt(groupId),
                    userId: parseInt(userId)
                },
                fetchPolicy: "no-cache",
                errorPolicy: "all"
            }).then((data) => {
       
                this.fetchGroupData(groupId);
                alert("User deleted");
            }).catch((error) => {
       
                alert("Failed to delete");
            });
        }
        else{

        }
    }

    render(){
        const { isViewGroupModalOpen, isConfirmModalOpen,groupMembers, 
                loading, groupId, isAddMember, options, selectValue } = this.state;

        const viewGroupModal = isViewGroupModalOpen ? <ViewGroupModal 
                                    isOpen={isViewGroupModalOpen}
                                    members={groupMembers}
                                    groupId={groupId}
                                    isAddMember={isAddMember}
                                    options={options}
                                    value={selectValue}
                                    toAddMembers={this.changeToAddMembersView}
                                    addMembers={this.addMembers}
                                    onClose={this.onCloseViewGroupModal}
                                    onSelectChange={this.onUsersSelectChange}
                                    removeMember={this.removeMember}
                                /> : null;

        const confirmDelete = isConfirmModalOpen ? 
                            <SweetAlertConfirm
                                onClose={this.onCloseConfirmModal}
                                onConfirm={this.deleteGroup.bind(this, this.state.selectedGroup)}
                                message="Delete this group?"
                                confirmBtnMsg="Delete"
                                headerTitle="Delete Group"
                            /> : null;

        let table = <ReactTable 
                        data={
                            this.state.groups.map((group, key) => {
                                return({
                                    id: key,
                                    groupId: group.groupId,
                                    name: group.name,
                                    actions: (
                                        <div className="actions-right">
                                            <Tooltip
                                                id="tooltip-top"
                                                title="View"
                                                placement="top"
                                            >
                                                <IconButton
                                                    onClick={this.openViewGroupModal.bind(this, group.groupId)}
                                                    color="primary"
                                                >
                                                <VisibilityIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="Remove group"
                                                placement="top"
                                            >
                                                <IconButton
                                                    onClick={this.openDeleteModal.bind(this, group.groupId)}
                                                    color="secondary"
                                                >
                                                <Close />
                                                </IconButton>
                                            </Tooltip>{" "}
                                        </div>
                                    )
                                })
                            })
                        }
                        columns={this.headers}
                        showPaginationTop
                        showPaginationBottom={false}
                        className="-striped -highlight"
                        pages={1}
                        loading={loading}
                        onFetchData={() => console.log("test")}
                    />

        return(
            <GridContainer>
                {confirmDelete}
                {viewGroupModal}
                <ItemGrid xs={12}>
                    <IconCard 
                        icon={CloudDownloadIcon}
                        title="Groups"
                        content={
                            <GridContainer>
                                <ItemGrid xs={12}>
                                    {table}
                                </ItemGrid>
                            </GridContainer>
                        }
                    />

                </ItemGrid>
            </GridContainer>
        )
    }
}

export default withApollo(Groups)


// WEBPACK FOOTER //
// ./src/views/projects/components/Groups.jsx